// extracted by mini-css-extract-plugin
export var externalLink = "_dp-0";
export var internalLinkLabel = "_dp-1";